import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: routes.innovation.path
    },
    {
      path: routes.forbidden.path,
      name: routes.forbidden.name,
      component: () => import('#webui/views/ForbiddenView.vue')
    },
    {
      path: routes.innovation.path,
      name: routes.innovation.name,
      component: () => import('#webui/views/InnovationListView.vue')
    },
    {
      path: routes.monitoring.path,
      name: routes.monitoring.name,
      component: () => import('#webui/views/InnovationDetailsView.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('#webui/views/ErrorView.vue')
    }
  ]
});

export default router;
